/**
 * Launcher V2 A2 U5 — pure "coverage by CM status" breakdown for the
 * Qualify step's coverage card. Ported semantics of the prototype's routing-
 * coverage card (v6 prototype ~line 5896), simplified to a plain by-status
 * tally of the seed campaign's REAL members — no suppression/routed/catch-all
 * bucketing, which would require evaluating filter groups against members
 * (PR B's `filterGroupsToSql`, not built in A2). This card reports real data
 * (product information), not version chrome, so it is not one of the
 * Decision-13 removals — it just can't claim a routing outcome A2 doesn't
 * compute.
 */

export interface CmStatusCoverageRow {
  status: string;
  count: number;
  /** Rounded 0-100; 0 when `members` is empty. */
  pct: number;
}

/** Members with a blank/null `cm_status` are grouped under "Unknown" rather than dropped. */
const UNKNOWN_STATUS = 'Unknown';

/** Sorted by count descending, so the most common status leads. */
export function coverageByCmStatus(
  members: ReadonlyArray<{ cm_status: string | null | undefined }>,
): CmStatusCoverageRow[] {
  const total = members.length;
  const counts = new Map<string, number>();
  for (const member of members) {
    const status = member.cm_status?.trim() || UNKNOWN_STATUS;
    counts.set(status, (counts.get(status) ?? 0) + 1);
  }
  return Array.from(counts.entries())
    .map(([status, count]) => ({
      status,
      count,
      pct: total === 0 ? 0 : Math.round((count / total) * 100),
    }))
    .sort((a, b) => b.count - a.count);
}
